import React from 'react';
import { MapPin, Flame } from 'lucide-react';
import { Badge } from './Badge';
interface FeatureImageCardProps {
  title: string;
  description: string;
  image: string;
  distance: string;
  heatScore: number;
  tags: string[];
}
export function FeatureImageCard({
  title,
  description,
  image,
  distance,
  heatScore,
  tags
}: FeatureImageCardProps) {
  return <div className="flex flex-col bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100 w-[280px] shrink-0" data-id="element-31">
      <div className="relative h-40" data-id="element-32">
        <img src={image} alt={title} className="w-full h-full object-cover" data-id="element-33" />
        <div className="absolute bottom-2 left-2 flex gap-1" data-id="element-34">
          {tags.map(tag => <Badge key={tag} variant="secondary" className="bg-white/90 text-[20rpx] px-1.5 py-0.5 rounded-md text-[#66CADA]" data-id="element-35">
              {tag}
            </Badge>)}
        </div>
      </div>
      <div className="p-3 flex flex-col gap-1" data-id="element-36">
        <h4 className="text-base font-bold text-[#333333] line-clamp-1" data-id="element-37">
          {title}
        </h4>
        <p className="text-xs text-[#999999] line-clamp-1" data-id="element-38">{description}</p>

        <div className="mt-3 flex items-center justify-between" data-id="element-39">
          <div className="flex items-center gap-1 text-[#999999]" data-id="element-40">
            <MapPin className="size-3" data-id="element-41" />
            <span className="text-[22rpx]" data-id="element-42">{distance}</span>
          </div>
          <div className="flex items-center gap-1 text-[#F35B5B]" data-id="element-43">
            <Flame className="size-3 fill-current" data-id="element-44" />
            <span className="text-[22rpx] font-bold" data-id="element-45">{heatScore}</span>
          </div>
        </div>
      </div>
    </div>;
}